var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"payComplete"}},[_c('h1',[_vm._v("Thank you for your contribution!")]),_vm._v(" "),_c('router-link',{staticClass:"button-submit",attrs:{"to":"/","id":"payCompleteReturnHome"}},[_vm._v("Return Home")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7030935e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/travel-calculator/PayComplete.vue
// module id = null
// module chunks = 